import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { formatHoursMinutesTextUntilTime } from 'src/app/util/format-utils';

@Component({
  selector: 'app-time-to-start-confirm',
  templateUrl: './time-to-start-confirm-modal.component.html',
  styleUrls: ['./time-to-start-confirm-modal.component.scss'],
})
export class TimeToStartConfirmModalComponent implements OnInit {

  @Input() cameFromMultiSelect: boolean = false;
  @Input() startTimestamp: string;

  timeUntilStart: string;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    this.timeUntilStart = formatHoursMinutesTextUntilTime(this.startTimestamp);
  }

  rejectTimeToStart() {
    this.modalCtrl.dismiss('reject');
  }

  confirmTimeToStart() {
    this.modalCtrl.dismiss('confirm');
  }

  getHeaderText() {
    return this.cameFromMultiSelect ? `A shift you've selected starts in ${this.timeUntilStart}` :
                                      `This job starts in ${this.timeUntilStart}`;
  }

  getConfirmText() {
    return this.cameFromMultiSelect ? 'Are you sure you\'d like this shift?' :
                                      'Are you sure you can make it?';
  }

  getConfirmButtonText() {
    return this.cameFromMultiSelect ? 'Yes, I want to work this shift' :
                                      'Yes, I\'ll be there';
  }

  getRejectText() {
    return this.cameFromMultiSelect ? 'Or, go back to the calendar to unselect this shift.' :
                                      'Or, you can withdraw now without penalty.';
  }

  getRejectButtonText() {
    return this.cameFromMultiSelect ? 'Change my selections' : 'Withdraw application'
  }
}
